import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const ResourceHero = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="container mx-auto relative mt-10 lg:mt-0 py-10">
        <div className="absolute lg:top-[25%] top-[35%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
          <h1 className="lg:text-5xl md:text-[25px] sm:text-[22px] text-[14px] text-black font-semibold text-center">
            Work with Your Time Zone <br /> and{" "}
            <span className="text-gradient-purple-secondary">
              Available 24/7
            </span>
          </h1>
          <p className="text-center text-black lg:mt-4 mt-2 lg:text-xl text-[7px]">
            We offered to provide a trusted talented loyal expert <br />{" "}
            resource on our own behalf on a fixed salary.
          </p>
        </div>
        {theme === "glassy" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./resource-hero-bg.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : theme === "light" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./resource-bg-light.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : theme === "dark" ? (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./resource-bg-dark.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        ) : (
          <div>
            <StaticImage
              className="mx-3 lg:mx-0"
              src="./resource-hero-bg.png"
              alt="resourceHero"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        )}
      </div>
    </>
  )
}
